import React from "react";
import { Container, Row, Col } from "react-bootstrap"
import homeBanner from "assets/home-main.svg"
import { Particles } from "components"
import { History, Techstack, Contact } from "./components"
import TypewriterEff from "typewriter-effect"
import localization from "utils/localization"

const STRINGS = [
    "Web & Mobile",
    "Javascript | Typescript | Node | Firebase",
    "React | Redux | Gatsby | VueJS",
    "UX/UI",
]

const Home = () => (
    <section>
        <Container fluid className="home-section" id="home">
            <Particles />
            <Container className="home-content">
                <Row>
                    <Col md={ 7 } className="home-header">
                        <h1 style={{ paddingBottom: 15 }} className="heading">
                            { localization('hi') } <span className="wave" role="img" aria-labelledby="wave">👋🏻</span>
                        </h1>
                        <h1 className="heading-name">
                            { localization('my-name') } <strong className="main-name"> Rodrigo Pasini de Souza</strong>
                        </h1>
                        <div style={{ padding: 50, textAlign: "left" }}>
                            <TypewriterEff options={{ strings: STRINGS, autoStart: true, loop: true, deleteSpeed: 50 }}/>
                        </div>
                    </Col>
                    <Col md={5} style={{ paddingBottom: 20 }}>
                        <img src={ homeBanner } alt="home pic" className="img-fluid" />
                    </Col>
                </Row>
            </Container>
        </Container>
        <History />
        <Container>
            <Techstack/>

            <Contact/>
        </Container>
    </section>
)

export default Home
